import React from "react";
export const renderHtmlContent = (
  htmlString: string
): React.ReactElement | string => {
  if (!htmlString) return "";

  // Split by <br/>, <br>, or <br /> tags and create React elements
  const parts = htmlString.split(/<br\s*\/?>/i);

  // If no br tags found, return the original string
  if (parts.length === 1) return htmlString;

  return (
    <>
      {parts.map((part, index) => (
        <span key={index}>
          {part}
          {index < parts.length - 1 && <br />}
        </span>
      ))}
    </>
  );
};
